import React from 'react';
import { Formik, Field } from 'formik';
import { Grid } from '@inplayer-org/inplayer-ui';

// utils
import JSONparse from 'utils/json-parse-safe';

// components
import { FullHeightForm, ContentContainer } from 'components/SharedStyledElements';
import Input from 'components/Fields/Input';
import FormAccordionHelper, { SectionType } from '../../components/AccordionHelper';

const { Container, Cell } = Grid;

interface FormValues {
  player_id: string;
  player_token: string;
  source_id: string;
}

const defaultValues: FormValues = {
  player_id: '',
  player_token: '',
  source_id: '',
};

interface Props {
  rawContent: string;
  onSubmit: (contentString: string, externalAssetId: string) => void;
  formId: string;
  isReadOnly: boolean;
  closePanel: () => void;
}

const FlowPlayerContent = ({ rawContent, onSubmit, formId, isReadOnly, closePanel }: Props) => {
  const content: FormValues = JSONparse(rawContent).value || {};

  const initialValues: FormValues = {
    ...defaultValues,
    ...content,
  };

  const handleSubmit = (data: FormValues) => {
    const contentString = JSON.stringify(data);
    const { source_id: externalAssetId } = data;

    onSubmit(contentString, externalAssetId.toString());
  };

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues}>
      {() => (
        <FullHeightForm id={formId}>
          <FormAccordionHelper initialValues={initialValues} index={SectionType.Content} closePanel={closePanel} />
          <ContentContainer withPadding>
            <Container columns={1} rowGap="1rem">
              <Cell>
                <Field
                  tag="text_input_player_id"
                  name="player_id"
                  label="Player Id"
                  component={Input}
                  disabled={isReadOnly}
                />
              </Cell>
              <Cell>
                <Field
                  tag="text_input_player_token"
                  name="player_token"
                  label="Player Token"
                  component={Input}
                  disabled={isReadOnly}
                />
              </Cell>
              <Cell>
                <Field
                  tag="text_input_source_id"
                  name="source_id"
                  label="Source Id"
                  component={Input}
                  disabled={isReadOnly}
                />
              </Cell>
            </Container>
          </ContentContainer>
        </FullHeightForm>
      )}
    </Formik>
  );
};

export default FlowPlayerContent;
